module.exports = __webpack_public_path__ + "static/media/bonus-circle.896ed305.png";